export const ACTION_RESET = 'FETCH_COMPANYDATALIST_RESET';
export const ACTION_REQUEST = 'FETCH_COMPANYDATALIST_REQUEST';
export const ACTION_SUCCESS = 'FETCH_COMPANYDATALIST_SUCCESS';
export const ACTION_ERROR = 'FETCH_COMPANYDATALIST_ERROR';
